import { useDatabase } from "@nozbe/watermelondb/hooks";
import React from "react";
import Department from "../../utilities/data/model/Department";
import { TextPropTypes, Text } from "@towersystems/roam-common-native";

const UNKNOWN_DEPARTMENT = "Unknown Department";

export type DepartmentIdToNameProps = TextPropTypes & {
  departmentId: string;
};

export const DepartmentIdToName = ({
  departmentId,
  ...props
}: DepartmentIdToNameProps) => {
  const [name, setName] = React.useState<string | undefined>(undefined);
  const database = useDatabase();

  React.useEffect(() => {
    (async () => {
      try {
        const department = await database
          .get<Department>("departments")
          .find(departmentId);

        setName(department.name ?? UNKNOWN_DEPARTMENT);
      } catch (err) {
        setName(UNKNOWN_DEPARTMENT);
      }
    })();
  }, [departmentId]);

  if (!name) {
    return null;
  }

  return <Text {...props}>{name}</Text>;
};
